/**
 * Backend #670: the customer's own contact block — the only customer fields a customer's
 * admin user may maintain without the Carrier (`PUT api/customer/{id}/contact`). The block
 * is replaced as a whole; an empty value clears the field. Everything else on the customer
 * (identity, address, tax ids, status flags) stays on the Carrier-only customer form.
 */
export interface CustomerContactUpdate {
  /** Published business contact address — max 320, must be a mailable address. */
  email: string | null;
  phone: string | null;
  fax: string | null;
  internet: string | null;
  description: string | null;
}

/** Mirrors the backend's `EmailAddressConstraints.MaxLength` (RFC 5321, the mail queue's limit). */
export const EMAIL_ADDRESS_MAX_LENGTH = 320;
